/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import T from 'i18n-react';

import MetaTags from 'Components/MetaTags/MetaTags';
import PageComposer from 'Components/PageComposer/PageComposer';
import StaticPages from 'Components/StaticPages/StaticPages';
import texts from 'Components/texts.json';
import { PAGE_SLUGS } from 'Utilities/consts';

T.setTexts(texts);

const VehiclePaymentPage = (): React.ReactElement => (
	<>
		<MetaTags
			// @ts-ignore needs to rewrite MetaTags to TS, and stop using withRouter for it to work
			noIndex
			description={T.translate('metaTags.pages.modulrPaymentsTerms.description')}
			title={T.translate('metaTags.pages.modulrPaymentsTerms.title')}
		/>
		<PageComposer pageSlug={PAGE_SLUGS.STATIC_PAGE}>
			<StaticPages fullWidth signUpSidebar={false} slug="modulr-payment-terms" />
		</PageComposer>
	</>
);
export default VehiclePaymentPage;
